/**
 * SessionList — lista de sesiones de relevamiento
 *
 * @module survey/components
 */

import type { SurveySession } from '../types/survey.types';
import { SessionStatusBadge } from './SessionStatusBadge';

interface Props {
  sessions: SurveySession[];
  isLoading: boolean;
  error: string | null;
  selectedId: string | null;
  onSelect: (session: SurveySession) => void;
}

function formatDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('es-AR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return iso;
  }
}

export function SessionList({
  sessions,
  isLoading,
  error,
  selectedId,
  onSelect,
}: Props): JSX.Element {
  if (isLoading) {
    return <div className="sw-list-state sw-list-loading">Cargando sesiones...</div>;
  }

  if (error) {
    return <div className="sw-list-state sw-list-error">{error}</div>;
  }

  if (sessions.length === 0) {
    return (
      <div className="sw-list-state sw-list-empty">
        No hay sesiones para este proyecto. Creá la primera.
      </div>
    );
  }

  return (
    <ul className="sw-session-list">
      {sessions.map(session => (
        <li key={session.id}>
          <button
            type="button"
            className={`sw-session-item${selectedId === session.id ? ' sw-session-item--active' : ''}`}
            onClick={() => onSelect(session)}
          >
            <div className="sw-session-item-name">{session.name}</div>
            <div className="sw-session-item-meta">
              <SessionStatusBadge status={session.status} />
              <span className="sw-session-item-date">{formatDate(session.createdAt)}</span>
            </div>
          </button>
        </li>
      ))}
    </ul>
  );
}
